module.exports = __webpack_public_path__ + "img/home.160567e6.svg";